

<div class="" style="padding:15px;background:#fff;">
  <div class="control-section">
    <div class="control-wrapper">
      <div class="default-section">
        <div class='forum'>
          <div class="questionSection">

            <div class="raiser">
              <table>
                <tbody>
                  <tr>
                    <td rowspan="2">
                      <div class="questionar">
                        <img style="border-radius: 50%" width="35" height="35" align="left" src="/Import/ShowImage_AnhCanBo/{{baivietSelect.NhanSuId}}" *ngIf="baivietSelect.CoAnh!='0'">
                        <img width="35" height="35" align="left" src="/assets/img/default.png" *ngIf="baivietSelect.CoAnh=='0'">
                      </div>
                    </td>
                    <td>
                      <div class="header">
                        {{baivietSelect.TieuDe}}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div class="Questionarname">
                        <em class="mr-2 far fa-user-circle"></em>{{baivietSelect.CreatedBy}}
                        <em class="icon-clock mr-2" style="margin-left:20px;"></em>{{baivietSelect.Created | date:'dd/MM/yyyy HH:mm'}}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="questionHeader">
              <div class="explain">
                <span [innerHtml]="baivietSelect.NoiDung"></span>
              </div>
              <div class="tags">
                <div class="full-tags">
                  <div class="tagSection">
                    <table>
                      <tbody>
                        <tr>
                          <td *ngFor='let row of baivietSelect.TuKhoas; let i = index'>
                            <div class="tag"> {{row.Value}} </div>
                          </td>

                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="questionLikes">
                    <table>
                      <tbody>
                        <tr>
                          <td>
                            <span class="e-icon e-like questionSide" (click)="likedispost(baivietSelect,1)">
                              <em class="icon-like mr-2" [ngClass]="{'liked': baivietSelect.DaLike === 1}"></em>
                              <span>{{baivietSelect.LuotLike}} Like</span>
                            </span>
                          </td>
                          <td>
                            <span class="e-icon e-dislike" (click)="likedispost(baivietSelect,0)">
                              <em class="icon-dislike mr-2" [ngClass]="{'liked': baivietSelect.DaDislike === 1}"></em>
                              <span> {{baivietSelect.LuotDislike}} Dislike</span>
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="reply-tags">
                 
                  <a (click)="deleterow(baivietSelect,1);" *ngIf="(username==baivietSelect.CreatedBy || quyen_xoa==true)">
                    <em class="ml-2 fas fa-times"></em>
                    {{'Xóa' | translate}}
                  </a>
                </div>
              </div>
            </div>
            <div class="separator"></div>
          </div>
         
        </div>
      </div>
    </div>
  </div>

</div>

